

    export const tableItemsP=[
        {
            Machine:"Punta Makinası",
            Brand:"JAJ 500 B",
            Year:2016,
            Head:120
        },
        {
            Machine:"Punta Makinası",
            Brand:"JAJ 500 D",
            Year:2018,
            Head:144
        },
        {
            Machine:"Punta Makinası",
            Brand:"MİLHAN",
            Year:2019,
            Head:48
        },
        
    ]